import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { firstValueFrom, skipWhile, take } from 'rxjs';
import { AuthState, selectHasRoles } from './auth.reducer';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(
    private _messageService: MessageService,
    private _store: Store<AuthState>
  ) {}

  async canActivate(next: ActivatedRouteSnapshot): Promise<boolean> {
    const allowedRoles: string[] = next.data['roles'];

    const hasAccess: boolean | undefined = await firstValueFrom(
      this._store.select(selectHasRoles(allowedRoles)).pipe(
        skipWhile(hasAccess => hasAccess === undefined),
        take(1)
      )
    );

    if (!hasAccess) {
      this._messageService.add({
        severity: 'error',
        detail: $localize`:@@common.message.no_access:You do not have the required roles to access the page`,
      });
      return false;
    }

    return true;
  }
}
